import urls from "global/constants/UrlConstants";
import { AddTeamFields } from "types/team";
import { getCallParams, makeCall } from "utils/service";

export const fetchTeamData = async (
  rowsPerPage: any,
  page: any,
  search: string
) => {
  const url = `${urls.GET_ALL_USER_WITH_SEARCH}/limit/${rowsPerPage}/page/${page}`;
  const payload = {
    searchText: search,
  };
  try {
    const callParams = await getCallParams("POST", payload);
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchTeamCount = async (search: string) => {
  const payload = {
    searchText: search,
  };
  try {
    const callParams = await getCallParams("POST", payload);
    const response: any = await makeCall(
      urls.GET_ALL_USER_WITH_SEARCH_COUNT,
      callParams
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};


export const addUser = async (user: AddTeamFields) => {
  try {
    const callParams = await getCallParams("POST", user);
    const response: any = await makeCall(urls.ADD_USER, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateUser = async (user: AddTeamFields) => {
  try {
    const callParams = await getCallParams("PATCH", user);
    const response: any = await makeCall(urls.UPDATE_USER, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
